import { useMutation } from "@apollo/client/react";
import useFetchShiftInstances from "hooks/apollo/shiftInstance/useFetchShiftInstances";
import { removeWorkBlocksForWorkOrder } from "hooks/apollo/workBlock/helpers/handleUpdateWorkBlocks";
import { useSchedulerState } from "hooks/state/index";
import useTimeZone from "hooks/useTimeZone";
import { UnscheduleWorkOrder } from "./workOrder.gql";

export default function useUnscheduleWorkOrder() {
  const { refetch: refetchShiftInstances } = useFetchShiftInstances();
  const [unscheduleWorkOrder] = useMutation(UnscheduleWorkOrder, {
    onCompleted: () => {
      refetchShiftInstances();
    },
  });
  const {
    state: { dataTimeRange },
  } = useSchedulerState();
  const { overrideToSiteTimeZone } = useTimeZone();

  return ({ workOrderId }) =>
    unscheduleWorkOrder({
      update: (proxy) => {
        const getAllBlocksVariables = {
          endsAt: overrideToSiteTimeZone(dataTimeRange.endDate),
          startsAt: overrideToSiteTimeZone(dataTimeRange.startDate),
        };
        return removeWorkBlocksForWorkOrder(workOrderId, proxy, getAllBlocksVariables);
      },
      variables: {
        id: workOrderId,
      },
    });
}
